//- 控制开关,dev、test、prod
var ENV = process.env.JOSH_ENV;

var link = {
	dev: {
		developer: 'http://192.168.3.163:8080/',
		community: 'http://192.168.3.125:8010/forum.php',
		website: 'http://192.168.3.163:8081/'
	},
	test: {
		developer: 'http://118.190.93.145:8040/',
		community: 'http://192.168.3.125:8010/forum.php',
		website: 'http://118.190.93.145:8032/'
	},
	prod: {
		developer: 'https://open.joshvm.com/',
		community: 'https://community.joshvm.com/',
		website: 'https://www.joshvm.com/'
	}
}

export default {
	links: link[ENV]
}


// WEBPACK FOOTER //
// ./src/options/base.js